import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  templateCard: {
    cursor: 'pointer',
    height: '100%',
    border: `2px solid ${theme.palette.secondary.superLight}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: theme.shadows[3],
    },
  },
  templateCardSelected: {
    borderColor: theme.palette.primary.main,
    boxShadow: theme.shadows[3],
  },
  templateCardNoBorder: {
    border: 'none',
    '&:hover': {
      borderColor: 'transparent',
      boxShadow: 'none',
    },
  },
  templateCardDisabled: {
    cursor: 'default',
    '&:hover': {
      borderColor: theme.palette.secondary.superLight,
      boxShadow: 'none',
    },
  },
  cardFooter: {
    padding: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  templateName: {
    fontWeight: 600,
    lineHeight: 1.3,
    marginRight: theme.spacing(0.5),
  },
  templateSubject: {
    fontSize: 12,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  defaultChip: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    fontSize: 10,
    height: 18,
    flexShrink: 0,
  },
  difficultyRow: {
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.75),
  },
  difficultyChip: {
    fontSize: 10,
    height: 18,
    fontWeight: 600,
  },
  difficulty_easy: {
    backgroundColor: theme.palette.phishing.difficulty.easy.background,
    color: theme.palette.phishing.difficulty.easy.text,
  },
  difficulty_medium: {
    backgroundColor: theme.palette.phishing.difficulty.medium.background,
    color: theme.palette.phishing.difficulty.medium.text,
  },
  difficulty_hard: {
    backgroundColor: theme.palette.phishing.difficulty.hard.background,
    color: theme.palette.phishing.difficulty.hard.text,
  },
  cardActions: {
    gap: theme.spacing(1),
    marginTop: 'auto',
    paddingTop: theme.spacing(1),
  },
  btnVisualize: {
    fontSize: 11,
    textTransform: 'none',
    flex: 1,
    whiteSpace: 'nowrap',
  },
  btnUse: {
    fontSize: 11,
    textTransform: 'none',
    flex: 1,
    whiteSpace: 'nowrap',
  },
  btnUseSelected: {
    color: theme.palette.white,
  },
}))

export default useStyles
